import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CardProvider } from './common';

import figoLogo from '../../../assets/brandProviderLogos/figo-logo.svg';
import ppiLogo from '../../../assets/brandProviderLogos/ppi-logo.png';
import ppiOnePackLogo
  from '../../../assets/brandProviderLogos/ppi-one-pack-logo.svg';
import akcLogo from '../../../assets/brandProviderLogos/akc-logo.svg';
import spotLogo from '../../../assets/brandProviderLogos/spot-logo.svg';

import { CONTACT_US_STEPS } from './contactUs.constants';
import { MARKETING_CHANNEL_ID } from '../../../theme/theme.constants';
import { ContactUsCompany } from './ContactUsCompany';
import { getThemeLogoById } from '../../../theme/theme.utils';

// Special scenario when the user has no session, we don't know
// what brands are expected to be rendered. So it renders all of them.
const ALL_CONTACT_US_COMPANIES = [
  { Id: MARKETING_CHANNEL_ID.figo },
  { Id: MARKETING_CHANNEL_ID.akc },
  { Id: MARKETING_CHANNEL_ID.ppi },
  { Id: MARKETING_CHANNEL_ID.ppiG },
  { Id: MARKETING_CHANNEL_ID.ppu },
  { Id: MARKETING_CHANNEL_ID.ppuPetCare },
  { Id: MARKETING_CHANNEL_ID.spotCan },
];

const ContactUsHome = ({
  contactInfo = {},
  insuranceCompanies = [],
  onProviderClick = () => { },
}) => {
  const { t } = useTranslation('sideMenu');
  const ppuTheme = getThemeLogoById(MARKETING_CHANNEL_ID.ppu);

  const companiesMemo = useMemo(() => {
    const companiesToRender = insuranceCompanies.length
      ? insuranceCompanies
      : ALL_CONTACT_US_COMPANIES;

    return companiesToRender.map((company) => {
      let item = {
        contactInfo: contactInfo.figoInfo,
        icon: figoLogo,
        name: 'figo',
        step: CONTACT_US_STEPS.FIGO,
      };

      switch (company.Id) {
        case MARKETING_CHANNEL_ID.akc:
          item = {
            contactInfo: contactInfo.akcInfo,
            icon: akcLogo,
            name: 'akc',
            step: CONTACT_US_STEPS.AKC,
          };
          break;

        case MARKETING_CHANNEL_ID.ppi:
          item = {
            contactInfo: contactInfo.ppiInfo,
            icon: ppiLogo,
            name: 'ppi',
            step: CONTACT_US_STEPS.PPI,
          };
          break;

        case MARKETING_CHANNEL_ID.ppiG:
          item = {
            contactInfo: contactInfo.ppiOnePackInfo,
            icon: ppiOnePackLogo,
            name: 'ppi-one-pack',
            step: CONTACT_US_STEPS.PPI_ONE_PACK,
          };
          break;

        case MARKETING_CHANNEL_ID.ppu:
          item = {
            contactInfo: contactInfo.ppuInfo,
            icon: ppuTheme.dark,
            name: 'ppu',
            step: CONTACT_US_STEPS.PPU,
          };
          break;

        case MARKETING_CHANNEL_ID.ppuPetCare:
          item = {
            contactInfo: contactInfo.ppuPetCareInfo,
            icon: ppuTheme.dark,
            name: 'ppu',
            step: CONTACT_US_STEPS.PPU_PET_CARE,
          };
          break;

        case MARKETING_CHANNEL_ID.spotCan:
          item = {
            contactInfo: contactInfo.spotCanInfo,
            icon: spotLogo,
            name: 'spot',
            step: CONTACT_US_STEPS.SPOT,
          };
          break;

        default:
          break;
      }

      return item;
    });
  }, [contactInfo, insuranceCompanies]);

  if (companiesMemo.length === 1) {
    const [company] = companiesMemo;

    return (
      <ContactUsCompany
        contactInfo={company.contactInfo}
        logo={company.icon}
        logoClass={`Contact-us-${company.name}-logo`}
      />
    );
  }

  return (
    <>
      <h1 className="Contact-us-modal-title">
        {t('contactUs.modalTitle')}
      </h1>

      <h3 className="Contact-us-modal-sub-title">
        {t('contactUs.modalSubTitle')}
      </h3>

      {companiesMemo.map(({ icon, name, step }) => (
        <CardProvider
          key={step}
          onClick={onProviderClick(step)}
          providerIcon={icon}
          providerIconStyle={`Contact-us-modal-${name}-icon`}
        />
      ))}
    </>
  );
};

export { ContactUsHome };
